import { 
    ACTUALIZAR_LIST_TAREASXPROCEDIMIENTO,
    AGREGAR_TAREASXPROCEDIMIENTO,
  } from "./tareasXprocedimientoActions";

  const tareasXprocedimientoReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_TAREASXPROCEDIMIENTO: {
            return {
                ...state,
                tareasXprocedimientoList: action.payload
            }
        };

        case AGREGAR_TAREASXPROCEDIMIENTO:{
            return {
                 ...state,
                 tareasXprocedimientoList: [action.payload, ...state.tareasXprocedimientoList]
             }
         };

        default:
            return state;

    }
  }

  export default tareasXprocedimientoReducer;